/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { faParking } from '@fortawesome/free-solid-svg-icons/faParking'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function ParkingNumbersField (props: FormTextFieldProps) {
  const { name = 'parkingNumbers', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'parking_numbers',
        defaultMessage: 'Numéros des places de parking'
      })}
      name={name}
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faParking}
        />
      )}
      {...others}
    />
  )
}

export default ParkingNumbersField
